import * as React from 'react';
import { SVGProps } from 'react';

const FileIconXlsSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width={24} height={28} rx={2} />
    <path
      opacity={0.5}
      d="M18 20h-3v2h3v-2ZM6 20v2h3v-2H6Zm4 0v2h4v-2h-4Zm8-1v-2h-3v2h3ZM6 19h3v-2H6v2Zm4 0h4v-2h-4v2Zm8-3v-2H6v2h3v-2h1v2h4v-2h1v2h3ZM5 13h14v10H5V13Z"
      fill="#fff"
    />
    <path
      d="M7 9H6V7h1V6H6V4h1v1.5L8 6l1-.5V4h1v2H9v1h1v2H9V7.5L8 7l-1 .5V9ZM12.92 9c-.227 0-.527-.08-.7-.24C12.053 8.6 12 8.347 12 8V3h-1V2h2v5.7c0 .107.027.183.08.23.053.047.143.07.27.07H14v1h-1.08ZM18 7.75c0 .42-.13.733-.39.94-.253.207-.623.31-1.11.31H15V8h1.45c.18 0 .317-.037.41-.11a.424.424 0 0 0 .14-.34v-.1c0-.3-.143-.45-.43-.45h-.37c-.467 0-.667-.1-.9-.3-.227-.207-.3-.53-.3-.97v-.47c0-.447.087-.767.34-.96.253-.2.667-.3 1.16-.3H18v1h-1.45c-.167 0-.3.04-.4.12-.1.073-.15.183-.15.33v.11c0 .153.043.267.13.34.093.073.21.1.35.1h.15c.447 0 .787.12 1.02.34.233.213.35.533.35.96v.45Z"
      fill="#fff"
    />
  </svg>
);
export default FileIconXlsSizeS;
